module.exports = __webpack_public_path__ + "img/電気回路_6_6_4.65841586.png";